var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJointhecommunityTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70601 14.0433C13.2724 9.43965 20.3184 6.40466 23.8438 4.9383C33.9097 0.751554 36.0013 0.0242714 37.3646 0.000256057C37.6644 -0.00502584 38.3348 0.0692834 38.7691 0.421664C39.1358 0.719207 39.2367 1.12114 39.285 1.40325C39.3333 1.68535 39.3934 2.32799 39.3456 2.83013C38.8001 8.56147 36.4399 22.4699 35.2391 28.8891C34.731 31.6053 33.7306 32.516 32.762 32.6052C30.6571 32.7989 29.0588 31.2141 27.0201 29.8777C23.83 27.7866 22.0278 26.4848 18.9313 24.4443C15.3526 22.086 17.6725 20.7899 19.7119 18.6716C20.2457 18.1173 29.5198 9.68176 29.6993 8.91652C29.7217 8.82082 29.7426 8.46407 29.5306 8.2757C29.3187 8.08733 29.0059 8.15174 28.7802 8.20297C28.4602 8.27559 23.364 11.644 13.4914 18.3083C12.0449 19.3016 10.7346 19.7856 9.5607 19.7602C8.26653 19.7322 5.77708 19.0284 3.92642 18.4269C1.65652 17.689 -0.147558 17.2989 0.00953608 16.0458C0.0913605 15.3931 0.990184 14.7256 2.70601 14.0433Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointhecommunityTelegram);
export default __webpack_public_path__ + "static/media/jointhecommunity-telegram.85ab1f801b7b2e25119b26cd1827b646.svg";
export { ForwardRef as ReactComponent };